// src/pages/Services.jsx
import React, { useEffect, useRef, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import {
  Activity,
  Brain,
  ShieldPlus,
  Baby,
  Accessibility,
  Award,
  Cpu,
  Clock3,
  ArrowRight,
  Home,
  PersonStanding,
  Dumbbell,
  Phone,
} from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import physioImg from "../assets/Physiotherapist.png";
import postSurgeryImg from "../assets/services images/Post Surgery Rehabilitation.jpeg";
import musculoskeletalImg from "../assets/services images/Musculoskeletal Physiotherapy.jpeg";
import pediatricImg from "../assets/services images/Pediatric Physiotherapy.jpeg";
import neuroImg from "../assets/services images/Neuro Physiotherapy Rehab.jpeg";
import chiropracticImg from "../assets/services images/Chiropractic Therapy for Natural Pain Relief and Healing.jpeg";
import sportsInjuryImg from "../assets/services images/Sports Injury Physiotherapy.jpeg";
import geriatricImg from "../assets/services images/Geriatric Physiotherapy.jpeg";
import strokeImg from "../assets/services images/Stroke Rehabilitation.jpeg";
import frozenShoulderImg from "../assets/services images/Frozen Shoulder Rehabilitation.jpeg";
import aclPclImg from "../assets/services images/ACL & PCL Reconstruction Repair Rehabilitation.jpeg";
import homeServicesImg from "../assets/services images/Physiotherapy At Home Services.jpeg";

export default function Services() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [visibleCards, setVisibleCards] = useState([]);
  const cardRefs = useRef([]);

  const whatsappNumber = "919182643439";
  const whatsappLink = `https://wa.me/${whatsappNumber}`;

  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  const services = [
    {
      title: "Post Surgery Rehabilitation",
      description:
        "Post-surgery rehabilitation is a program of re-establishing proper joint movements, muscle strength around the joint and joint function.",
      image: postSurgeryImg,
      icon: <ShieldPlus size={18} />,
    },
    {
      title: "Musculoskeletal Physiotherapy",
      description:
        "Musculoskeletal Physiotherapy involves proper treatments of disorders, which affect how you move or how your joints and muscles work together.",
      image: musculoskeletalImg,
      icon: <Accessibility size={18} />,
    },
    // {
    //   title: "Vestibular Rehabilitation",
    //   description:
    //     "Vestibular rehabilitation therapy or VRT is physical therapy that uses specialized exercises resulting in gaze and gait stabilization.",
    //   image:
    //     "https://images.unsplash.com/photo-1584515933487-779824d29309?auto=format&fit=crop&w=1200&q=80",
    //   icon: <Brain size={18} />,
    // },
    {
      title: "Pediatric Physiotherapy",
      description:
        "Pediatric physiotherapists are mostly trained to help children achieve their final physical development.",
      image: pediatricImg,
      icon: <Baby size={18} />,
    },
    // {
    //   title: "Women's Health Physiotherapy",
    //   description:
    //     "Women's health physiotherapy comes from the clinical area of Obstetrics and Gynecology, and it focuses on childbirth, postnatal, and antenatal care.",
    //   image:
    //     "https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?auto=format&fit=crop&w=1200&q=80",
    //   icon: <HeartPulse size={18} />,
    // },
    {
      title: "Neuro Physiotherapy Rehab",
      description:
        "Neurological physiotherapy is a special physiotherapy area focusing on treatments of individuals with neurological conditions.",
      image: neuroImg,
      icon: <Brain size={18} />,
    },
    {
      title: "Chiropractic Therapy for Natural Pain Relief and Healing",
      description:
        "Chiropractic is a healthcare treatment that mainly cares for the neuro-musculoskeletal system of the patient.",
      image: chiropracticImg,
      icon: <PersonStanding size={18} />,
    },
    {
      title: "Sports Injury Physiotherapy",
      description:
        "The primary role of sports physiotherapists is to prevent and manage injuries resulting from exercise and sport participation of all ages.",
      image: sportsInjuryImg,
      icon: <Dumbbell size={18} />,
    },
    {
      title: "Geriatric Physiotherapy",
      description:
        "Geriatric Physiotherapy is a branch of physiotherapy that helps in managing physical issues in elderly people.",
      image: geriatricImg,
      icon: <Activity size={18} />,
    },
    {
      title: "Stroke Rehabilitation",
      description:
        "Stroke rehabilitation physiotherapy helps patients regain movement, balance, strength, and independence following a stroke through targeted exercises and neuroplasticity-based therapies.",
      image: strokeImg,
      icon: <Brain size={18} />,
    },
    {
      title: "Frozen Shoulder Rehabilitation",
      description:
        "Frozen shoulder rehabilitation focuses on restoring full range of motion, reducing pain, and improving shoulder function through progressive stretching, manual therapy, and strengthening exercises.",
      image: frozenShoulderImg,
      icon: <PersonStanding size={18} />,
    },
    {
      title: "ACL & PCL Reconstruction Repair Rehabilitation",
      description:
        "ACL and PCL reconstruction rehabilitation guides patients through progressive recovery phases — from early post-operative care to full return to sport — using targeted strengthening, neuromuscular training, and functional movement programs.",
      image: aclPclImg,
      icon: <Dumbbell size={18} />,
    },
    {
      title: "Physiotherapy At Home Services",
      description:
        "Physiotherapy at home mainly occurs within 24 hours of hospital discharge and supports proper recovery in a home environment.",
      image: homeServicesImg,
      icon: <Home size={18} />,
    },
  ];

  const features = [
    {
      icon: <Award size={18} />,
      title: "Expert Specialists",
      text: "Our team consists of board-certified physiotherapists with years of specialized experience.",
      color: "#0ea5ff",
      bg: "#e0f2fe",
    },
    {
      icon: <Cpu size={18} />,
      title: "Advanced Technology",
      text: "We use modern rehabilitation equipment and diagnostic tools for precise treatment.",
      color: "#84cc16",
      bg: "#ecfccb",
    },
    {
      icon: <Clock3 size={18} />,
      title: "Flexible Scheduling",
      text: "Appointments are available to fit your daily routine comfortably.",
      color: "#38bdf8",
      bg: "#e0f2fe",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.dataset.index);

          if (entry.isIntersecting) {
            setVisibleCards((prev) =>
              prev.includes(index) ? prev : [...prev, index],
            );
          } else {
            setVisibleCards((prev) => prev.filter((item) => item !== index));
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: "0px 0px -10% 0px",
      },
    );

    cardRefs.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  const getAnimationClass = (index) => {
    const pattern = ["card-left", "card-top", "card-right"];
    return pattern[index % 3];
  };

  return (
    <>
      <Navbar />

      <style>{`
        html {
          scroll-behavior: smooth;
        }

        @keyframes slideFromLeft {
          0% {
            opacity: 0;
            transform: translateX(-90px);
          }
          100% {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slideFromTop {
          0% {
            opacity: 0;
            transform: translateY(-90px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideFromRight {
          0% {
            opacity: 0;
            transform: translateX(90px);
          }
          100% {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes whatsappPulse {
          0% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5);
          }
          70% {
            box-shadow: 0 0 0 14px rgba(37, 211, 102, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
          }
        }

        .hero-button {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .hero-button:hover {
          transform: translateY(-4px);
        }

        /* IMPORTANT FIX */
        .service-card {
          opacity: 0;
          transition: box-shadow 0.35s ease, transform 0.35s ease;
          will-change: transform, opacity;
        }

        /* Hidden positions */
        .service-card.card-left {
          transform: translateX(-90px);
        }

        .service-card.card-top {
          transform: translateY(-90px);
        }

        .service-card.card-right {
          transform: translateX(90px);
        }

        /* Show animation */
        .service-card.show.card-left {
          animation: slideFromLeft 0.8s ease;
          opacity: 1;
          transform: translateX(0);
        }

        .service-card.show.card-top {
          animation: slideFromTop 0.8s ease;
          opacity: 1;
          transform: translateY(0);
        }

        .service-card.show.card-right {
          animation: slideFromRight 0.8s ease;
          opacity: 1;
          transform: translateX(0);
        }

        .service-card:hover {
          box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
        }

        .service-card.show:hover {
          transform: translateY(-8px);
        }

        .service-card:hover .service-image {
          transform: scale(1.06);
        }

        .service-image {
          transition: transform 0.5s ease;
        }

        .service-arrow {
          transition: transform 0.3s ease;
        }

        .service-card:hover .service-arrow {
          transform: translateX(6px);
        }

        .feature-box {
          transition: transform 0.3s ease;
        }

        .feature-box:hover {
          transform: translateX(6px);
        }

        .whatsapp-float {
          position: fixed;
          right: 22px;
          bottom: 22px;
          width: 62px;
          height: 62px;
          border-radius: 50%;
          background: #25D366;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          z-index: 9999;
          box-shadow: 0 14px 30px rgba(37, 211, 102, 0.35);
          animation: whatsappPulse 2s infinite;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .whatsapp-float:hover {
          transform: translateY(-5px) scale(1.05);
          box-shadow: 0 18px 34px rgba(37, 211, 102, 0.42);
        }

        .whatsapp-label {
          position: fixed;
          right: 94px;
          bottom: 38px;
          background: #111827;
          color: #fff;
          padding: 10px 14px;
          border-radius: 999px;
          font-size: 13px;
          font-weight: 600;
          z-index: 9998;
          box-shadow: 0 8px 20px rgba(15,23,42,0.18);
        }

        @media (max-width: 768px) {
          .whatsapp-float {
            width: 56px;
            height: 56px;
            right: 16px;
            bottom: 16px;
          }

          .whatsapp-label {
            display: none;
          }
        }
      `}</style>

      <div style={{ background: "#f3f5f7", overflowX: "hidden" }}>
        <section
          style={{
            background:
              "linear-gradient(90deg, #020912 0%, #061a3d 45%, #0d2c73 100%)",
            padding: isMobile ? "80px 16px 90px" : "95px 24px 110px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              textAlign: "center",
            }}
          >
            <h1
              style={{
                margin: 0,
                color: "#ffffff",
                fontSize: isMobile ? "2.4rem" : "4.1rem",
                lineHeight: 1.08,
                fontWeight: 800,
                letterSpacing: "-1px",
              }}
            >
              Advanced
              <br />
              <span
                style={{
                  background: "linear-gradient(90deg, #13b8ff, #76e23b)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Physiotherapy Solutions
              </span>
            </h1>

            <p
              style={{
                maxWidth: "760px",
                margin: "22px auto 34px",
                color: "rgba(255,255,255,0.72)",
                fontSize: isMobile ? "15px" : "20px",
                lineHeight: 1.7,
              }}
            >
              Recover faster with our state-of-the-art treatments tailored to
              your body&apos;s unique needs. Experience the perfect blend of
              care and clinical excellence.
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "16px",
                flexWrap: "wrap",
              }}
            >
              <a
                href="#expertise"
                className="hero-button"
                style={{
                  textDecoration: "none",
                  background: "linear-gradient(90deg, #0ea5ff, #18c4ff)",
                  color: "#fff",
                  fontWeight: 700,
                  padding: "15px 30px",
                  borderRadius: "999px",
                  boxShadow: "0 10px 28px rgba(14,165,255,0.35)",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                Explore Services <ArrowRight size={16} />
              </a>

              <a
                href="#contact-cta"
                className="hero-button"
                style={{
                  textDecoration: "none",
                  color: "#dbe7ff",
                  fontWeight: 700,
                  padding: "14px 28px",
                  borderRadius: "999px",
                  border: "1px solid rgba(255,255,255,0.45)",
                  background: "transparent",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                Book Appointment <Phone size={16} />
              </a>
            </div>
          </div>
        </section>

        <section
          id="expertise"
          style={{
            padding: isMobile ? "60px 16px" : "82px 24px 90px",
            background:
              "linear-gradient(180deg, #f8fbff 0%, #eef7f7 50%, #f8fbff 100%)",
          }}
        >
          <div style={{ maxWidth: "1250px", margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: "48px" }}>
              <div
                style={{
                  display: "inline-block",
                  color: "#84cc16",
                  background: "#f0fdf4",
                  border: "1px solid #d9f99d",
                  fontWeight: 800,
                  fontSize: "12px",
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  marginBottom: "14px",
                  padding: "10px 18px",
                  borderRadius: "999px",
                }}
              >
                Our Expertise
              </div>

              <h2
                style={{
                  margin: 0,
                  color: "#182338",
                  fontSize: isMobile ? "2rem" : "3.15rem",
                  fontWeight: 800,
                  lineHeight: 1.15,
                }}
              >
                Comprehensive Care Treatments
              </h2>

              <p
                style={{
                  maxWidth: "760px",
                  margin: "16px auto 0",
                  color: "#64748b",
                  fontSize: isMobile ? "14px" : "17px",
                  lineHeight: 1.8,
                }}
              >
                Personalized physiotherapy solutions designed for pain relief,
                mobility restoration, strength building, and long-term wellness.
              </p>

              <div
                style={{
                  width: "90px",
                  height: "5px",
                  borderRadius: "999px",
                  margin: "18px auto 0",
                  background: "linear-gradient(90deg, #14b8ff, #84cc16)",
                }}
              />
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobile
                  ? "1fr"
                  : "repeat(auto-fit, minmax(320px, 1fr))",
                gap: "28px",
              }}
            >
              {services.map((item, index) => (
                <div
                  key={index}
                  ref={(el) => (cardRefs.current[index] = el)}
                  data-index={index}
                  className={`service-card ${getAnimationClass(index)} ${visibleCards.includes(index) ? "show" : ""
                    }`}
                  style={{
                    background: "#ffffff",
                    borderRadius: "22px",
                    overflow: "hidden",
                    boxShadow: "0 10px 28px rgba(15,23,42,0.07)",
                    border: "1px solid #e8eef5",
                    cursor: "pointer",
                  }}
                >
                  <div style={{ position: "relative", overflow: "hidden" }}>
                    <img
                      src={item.image}
                      alt={item.title}
                      className="service-image"
                      style={{
                        width: "100%",
                        height: "220px",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />

                    <div
                      style={{
                        position: "absolute",
                        inset: 0,
                        background:
                          "linear-gradient(to top, rgba(2,6,23,0.45), rgba(2,6,23,0.08))",
                      }}
                    />

                    <div
                      style={{
                        position: "absolute",
                        left: "18px",
                        bottom: "18px",
                        width: "52px",
                        height: "52px",
                        borderRadius: "14px",
                        background: "linear-gradient(135deg, #84cc16, #22c55e)",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 10px 22px rgba(132,204,22,0.28)",
                      }}
                    >
                      {item.icon}
                    </div>
                  </div>

                  <div style={{ padding: "24px 20px 20px" }}>
                    <h3
                      style={{
                        margin: "0 0 14px",
                        color: "#0f172a",
                        fontSize: isMobile ? "1.3rem" : "1.5rem",
                        fontWeight: 800,
                        lineHeight: 1.3,
                        minHeight: isMobile ? "auto" : "64px",
                      }}
                    >
                      {item.title}
                    </h3>

                    <p
                      style={{
                        margin: "0 0 20px",
                        color: "#64748b",
                        lineHeight: 1.8,
                        fontSize: "14px",
                        minHeight: isMobile ? "auto" : "128px",
                      }}
                    >
                      {item.description}
                    </p>

                    <div
                      style={{
                        borderTop: "1px solid #e7ebf0",
                        paddingTop: "15px",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <a
                        href="#contact-cta"
                        style={{
                          textDecoration: "none",
                          color: "#0ea5ff",
                          fontWeight: 800,
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "7px",
                        }}
                      >
                        Read More
                        <ArrowRight className="service-arrow" size={15} />
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section
          style={{
            // background: "#f8faf8",
            padding: isMobile ? "62px 16px" : "82px 24px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
              gap: isMobile ? "34px" : "60px",
              alignItems: "center",
            }}
          >
            <div>
              <div
                style={{
                  borderRadius: "20px",
                  overflow: "hidden",
                  // boxShadow: "0 18px 40px rgba(15,23,42,0.12)",
                }}
              >
                <img
                  src={physioImg}
                  alt="Patient-Centric Recovery"
                  style={{
                    width: "100%",
                    height: isMobile ? "360px" : "520px",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </div>
            </div>

            <div>
              <div
                style={{
                  color: "#84cc16",
                  fontWeight: 800,
                  fontSize: "12px",
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  marginBottom: "10px",
                }}
              >
                Why Elite Care?
              </div>

              <h2
                style={{
                  margin: "0 0 18px",
                  color: "#182338",
                  fontSize: isMobile ? "2rem" : "3rem",
                  lineHeight: 1.15,
                  fontWeight: 800,
                }}
              >
                Patient-Centric Recovery
              </h2>

              <p
                style={{
                  color: "#64748b",
                  lineHeight: 1.9,
                  fontSize: "16px",
                  marginBottom: "28px",
                }}
              >
                At Elite Care, we combine advanced medical technology with
                compassionate hands-on therapy. Our goal is to support faster
                recovery, pain relief, and long-term wellness.
              </p>

              <div style={{ display: "grid", gap: "24px" }}>
                {features.map((feature, i) => (
                  <div
                    key={i}
                    className="feature-box"
                    style={{
                      display: "flex",
                      gap: "14px",
                      alignItems: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        width: "34px",
                        height: "34px",
                        minWidth: "34px",
                        borderRadius: "999px",
                        background: feature.bg,
                        color: feature.color,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: "4px",
                      }}
                    >
                      {feature.icon}
                    </div>

                    <div>
                      <div
                        style={{
                          color: "#1e293b",
                          fontWeight: 800,
                          marginBottom: "4px",
                          fontSize: "1.15rem",
                        }}
                      >
                        {feature.title}
                      </div>

                      <div
                        style={{
                          color: "#64748b",
                          lineHeight: 1.8,
                          fontSize: "15px",
                        }}
                      >
                        {feature.text}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section
          id="contact-cta"
          style={{
            background:
              "linear-gradient(90deg, #051a33 0%, #082546 50%, #0b2c4e 100%)",
            padding: isMobile ? "70px 16px" : "90px 24px",
          }}
        >
          <div
            style={{
              maxWidth: "1000px",
              margin: "0 auto",
              textAlign: "center",
            }}
          >
            <h2
              style={{
                margin: 0,
                color: "#ffffff",
                fontSize: isMobile ? "2.2rem" : "3.6rem",
                lineHeight: 1.15,
                fontWeight: 800,
              }}
            >
              Ready to start your recovery?
            </h2>

            <p
              style={{
                margin: "20px 0 34px",
                color: "rgba(255,255,255,0.76)",
                fontSize: isMobile ? "15px" : "20px",
                lineHeight: 1.7,
              }}
            >
              Don&apos;t let pain hold you back. Schedule your initial
              consultation today.
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "16px",
                flexWrap: "wrap",
              }}
            >
              <a
                href={whatsappLink}
                target="_blank"
                rel="noreferrer"
                className="hero-button"
                style={{
                  textDecoration: "none",
                  background: "#84cc16",
                  color: "#ffffff",
                  fontWeight: 800,
                  padding: "16px 30px",
                  borderRadius: "999px",
                  boxShadow: "0 10px 24px rgba(132,204,22,0.28)",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                Book Appointment Now <FaWhatsapp size={18} />
              </a>

              <a
                href="tel:+919182643439"
                className="hero-button"
                style={{
                  textDecoration: "none",
                  background: "transparent",
                  color: "#dce8ff",
                  fontWeight: 700,
                  padding: "15px 28px",
                  borderRadius: "999px",
                  border: "1px solid rgba(255,255,255,0.35)",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                Contact Us <Phone size={16} />
              </a>
            </div>
          </div>
        </section>
      </div>

      {/* <div className="whatsapp-label">Chat on WhatsApp</div>
      <a
        href={whatsappLink}
        target="_blank"
        rel="noreferrer"
        className="whatsapp-float"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp size={30} />
      </a> */}

      <Footer />
    </>
  );
}
